import { buildPayloadApiUrl, payloadFetch } from "./client";
import { mapPokerCarouselResponse } from "src/utils/mapPokerCarousel";

/**
 * Fetches poker page carousel slides from pg-payload-cms (`poker-carousel`).
 * Filtering by publish/unpublish dates is done client-side via shouldPublish().
 * Enabled when `carousels` is listed in `REACT_APP_PAYLOAD_SOURCES`
 * (same flag as the home + EGD carousels).
 *
 * @param {string} locale - `en` | `fr`
 * @returns {Promise<import('src/utils/mapPokerCarousel').PokerCarouselSlide[]>}
 */
export async function fetchPokerCarousel(locale) {
  const url = buildPayloadApiUrl("/api/poker-carousel", {
    locale,
    limit: 50,
    sort: "_order",
    depth: 0,
  });

  const response = await payloadFetch(url);
  return mapPokerCarouselResponse(response, locale);
}
